import { StyledCardSurface } from './styled'
import { CardSurfaceProps } from './types'

/**
 * The white-card chrome used across signed-in surfaces (sign-in, dashboard,
 * profile, onboarding steps). Soft purple-tinted shadow, rounded corners,
 * three padding presets.
 *
 * @param {CardSurfaceProps} props
 * @returns {JSX.Element}
 */
const CardSurface = ({
  children,
  className,
  padding = 'standard',
}: CardSurfaceProps): JSX.Element => {
  return (
    <StyledCardSurface padding={padding} className={className}>
      {children}
    </StyledCardSurface>
  )
}

export default CardSurface
